const defaultState = () => ({
    orders: [],
    Activeorders: {},
    orderPagination: {},
});

const mutations = {
    setOrders(state, content) {
        state.orders = content.pagination.currentPage !== state.orderPagination.currentPage
            ? [...state.orders, ...content.orders] : content.orders;
        state.orderPagination = content.pagination;
    },
    setActiveOrders(state, orders) {
        state.Activeorders = orders.find(or => or.active);
    },
};

const actions = {
    async getOrderItems({ commit, dispatch }, payload) {
        try {
            if (!payload.params) {
                // eslint-disable-next-line no-param-reassign
                payload.params = {};
            }
            const { data } = await this.$rq.getOrders(payload.siteId, payload.params);
            commit('setOrders', data);
            commit('setActiveOrders', data.orders);
        } catch (err) {
            dispatch('resetOrders');
        }
    },
};

const getters = {
    orders: state => state.orders,
    activeOrders: state => state.Activeorders,
    orderPagination: state => state.orderPagination,
};

const state = defaultState();

export default {
    state,
    getters,
    actions,
    mutations,
};
